import React, { FunctionComponent } from 'react';
import {
  StyleProp, StyleSheet, Text, View, ViewStyle,
} from 'react-native';
import { HideScrollBarOnWeb } from '../../components/HideScrollBarOnWeb';
import Theme from '../../theme';
import { SkeletonLoader } from '../../ui';
import { defaultScale } from '../../utils/scaling';
import { horizontalScrollConstants } from './HorizontalScroller';

interface IProps {
  heading?: string;
  children: React.ReactNode;
  isLoading?: boolean;
  childContainerStyle?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
}

export const DashboardSection: FunctionComponent<IProps> = ({
  heading,
  children,
  isLoading = false,
  childContainerStyle,
  containerStyle,
}) => {
  const loaderStyle = {
    marginLeft: horizontalScrollConstants.CARD_MARGIN,
    width: horizontalScrollConstants.CARD_WIDTH_WIDE,
    borderRadius: horizontalScrollConstants.CARD_BOARDER_RADIUS,
    height: horizontalScrollConstants.CARD_HEIGHT,
  };

  return (
    <HideScrollBarOnWeb>
      <View style={[styles.container, containerStyle]}>
        <Text style={styles.heading}>{heading}</Text>
        <View style={styles.contentContainer}>
          {
          isLoading
            ? <SkeletonLoader containerStyle={loaderStyle} />
            : (
              <View style={[styles.childContainer, childContainerStyle]}>
                {children}
              </View>
            )
          }
        </View>
      </View>
    </HideScrollBarOnWeb>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: defaultScale(14),
  },
  heading: {
    ...Theme.textStyle.bodyCopyBold,
    marginBottom: defaultScale(5),
    marginLeft: defaultScale(12),
  },
  contentContainer: {
    position: 'relative',
  },
  childContainer: {
    height: horizontalScrollConstants.CARD_HEIGHT,
  },
});
